import React, { useState, useEffect } from 'react';
import { acceptInvitation } from '../services/api';
import { Button, Box, Text, Stack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

export default function UserInviteAccept() {
    const [token, setToken] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        
        if (token) {
            setToken(token);
            acceptInvitation(token)
                .then(() => {
                    setIsLoading(false);
                })
                .catch((error) => {
                    setError(error);
                    setIsLoading(false);
                });
        } else {
            setError({message: 'トークンがありません'});
            setIsLoading(false);
        }
    }, []);

    return (
        <div>
            {isLoading ? (
                <div>Loading...</div>
            ) : (
                <div>
                    {!error && (
                        <div>
                            <Text>招待が承認されました。</Text>
                            <Text>ログインしてください。</Text>
                        </div>
                    )}
                    {error && 
                        <div>
                            <Text>エラーが発生しました。既に承認済みの場合は、ログインしてください</Text>
                            <Text color="red">{JSON.parse(error.message).detail}</Text>
                        </div>}
                    <Button bg="black" color="white" onClick={() => {
                        navigate('/');
                    }}>ログイン</Button>
                </div>
            )}
        </div>
    )
}